<!--
  成果列表
 -->
<template>
  <div class="tabpane_content">
    <div class="content_header">
      <el-input
        style="width:300px;margin-right: 10px;"
        size="small"
        placeholder="请输入成果名称"
        suffix-icon="el-icon-search"
        v-model="searchCondition.keywords"
        @keyup.native.enter="onSearch">
      </el-input>
      <!-- <el-select
        size="small"
        style="width:200px;margin-right: 10px;"
        v-model="searchCondition.achievementType"
        :clearable="true"
        placeholder="请选择成果类型"
        @change="onSearch">
        <el-option
          v-for="item in achievementTypeOptions"
          :key="item"
          :label="item"
          :value="item">
        </el-option>
      </el-select>
      <el-select
        size="small"
        style="width:200px;margin-right: 10px;"
        v-model="searchCondition.logicStatus"
        :clearable="true"
        placeholder="请选择成果状态"
        @change="onSearch">
        <el-option
          v-for="item in logicStatusOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select> -->
    </div>
    <div class="content_main">
      <el-table
        v-loading="loading"
        :header-cell-style="headerCellStyle"
        :data="tableData"
        style="width: 100%"
        @row-click="onDetail">
        <el-table-column
          label="序号"
          type="index"
          :index="indexMethod">
        </el-table-column>
        <el-table-column
          label="成果名称"
          prop="title">
        </el-table-column>
        <el-table-column
          label="类型"
          prop="achievementType">
        </el-table-column>
        <el-table-column
          prop="operatorAt"
          label="审核时间">
        </el-table-column>
      </el-table>
    </div>
    <div class="content_footer">
      <el-pagination
        hide-on-single-page
        background
        @current-change="pageNumChange"
        :current-page.sync="pagination.pageNum"
        :page-size="pagination.pageSize"
        layout="prev, pager, next, jumper"
        :total="pagination.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import * as api from '@/api'
import globalVar from '@/configs/globalVar'
import staticData from '@/configs/data'
export default {
  data () {
    return {
      loading: false,
      exportBtnLoading: false,
      // 搜索对象
      searchCondition: {
        keywords: '',
        achievementType: '', // 成果类型
        logicStatus: ''
      },
      logicStatusOptions: [
        { label: '已通过', value: globalVar.ACHIEVEMENT_STATUS_1 },
        { label: '已驳回', value: globalVar.ACHIEVEMENT_STATUS_2 },
        { label: '已下架', value: globalVar.ACHIEVEMENT_STATUS_3 }
      ],
      // 成果类型
      achievementTypeOptions: staticData.cglx,
      // 表格数据
      tableData: [],
      // 分页对象
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  computed: {
    // 表格头
    headerCellStyle () {
      return this.$store.state.headerCellStyle
    },
    globalVar () {
      return globalVar
    }
  },
  created () {
    this.getTableData()
  },
  methods: {
    // 获取表格数据
    getTableData (pageNum) {
      this.loading = true
      const searchVar = this.getSearchVar()
      api.getMyReviewAchievementsList({
        ...searchVar,
        pageNum,
        pageSize: this.pagination.pageSize
      }).then(res => {
        if (res.data.code === 0) {
          this.pagination.pageNum = res.data.data.currentPage
          this.pagination.total = res.data.data.total
          this.tableData = res.data.data.list
        } else {
          this.$message.error(res.data.message)
        }
        this.loading = false
      }).catch(err => {
        this.loading = false
        console.log(err)
        this.$message.error('请求出错')
      })
    },
    // 获取搜索条件
    getSearchVar () {
      // 再把状态以否号分隔
      const logicStatus = this.searchCondition.logicStatus || `${globalVar.ACHIEVEMENT_STATUS_1},${globalVar.ACHIEVEMENT_STATUS_2},${globalVar.ACHIEVEMENT_STATUS_3}`
      const keywords = this.searchCondition.keywords
      const achievementType = this.searchCondition.achievementType
      return {
        logicStatus,
        keywords,
        achievementType
      }
    },
    // 搜索
    onSearch () {
      this.getTableData(1)
    },
    // 页码变化
    pageNumChange (pageNum) {
      this.getTableData(pageNum)
    },
    // 详情页
    onDetail (row) {
      window.open(`/resource-require/achievement/detail/${row.id}`)
    },
    // 序号
    indexMethod (index) {
      return this.pagination.pageSize * (this.pagination.pageNum - 1) + index + 1
    }
  }
}
</script>

<style lang="scss" scoped>
  .tabpane_content {
    padding: 15px 25px;
    .content_header {
      display: flex;
      margin-bottom: 20px;
    }
    .content_main {
      margin-bottom: 20px;
    }
    .content_footer {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 40px;
    }
  }
</style>
